/* Important Info component for the Character Create page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/PostCreateEditForm.module.css";

const Important = () => {
  return (
    <div className="mb-5">
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <p className={`${styles.Red} text-center`}>IMPORTANT</p>
          <hr className={`mt-2 mb-0`}/>
          <p className={`pt-2`}>
          Cast Info is contained here in the Characters Section.
          </p>
          <p className={`pt-3`}>
          <span className={`${styles.Red}`}>*</span> The Actor playing the Character <span className={`${styles.Red}`}>MUST</span>:
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>-</span> Be registered in <span className={`${styles.Red}`}>Manage Users</span> and the <span className={`${styles.Red}`}>Callname</span>, which 
          displays on their Character's Edit page, added in the form's "Callname" field.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>-</span> Have their Name and Email entered on their <span className={`${styles.Red}`}>Character's Edit</span> page.
          </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> The Character's <span className={`${styles.Red}`}>Costume</span> Details and Images are added on the Edit Character page.
          </p>
          <p className={`pt-3 ${styles.SmallWhite}`}>
          Note: Moodboards and Scene Workshops are to be used to collaborate the Character before final choices are made.
          </p>
          <p className={`pt-2 ${styles.SmallWhite}`}>
          Note: Characters should never be deleted as long as the actor is needed.
          </p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default Important